export const OPTIMIZELY_EVENTS = {
	BID_PLACED: 'Bid placed event',
	CONDITION_AND_DAMAGE_PHOTO_CLICKED: 'Condition and damage photo clicked',
	GRADING_MODAL_OPENED: 'Grading modal opened event',
	GRADING_RATING_ITEM_CLICKED: 'Grading rating item clicked event',
	RECOMMENDED_SORT_ORDER_BOUNCE_RATE: 'Recommended sort order bounce rate event',
	VEHICLE_CARD_CLICKED: 'Vehicle card clicked event',
	VEHICLE_LIST_FETCHED_WITH_GRADING_FILTER: 'Vehicle list fetched with grading filter event',
};

// These are actually flag keys
export enum EXPERIMENTS {
	DEALER_DASHBOARD = 'dealer_dashboard_experiment',
	RECOMMENDED_SORT_ORDER = 'explorers_recommended_sort_order_experiment',
	SERVICE_HISTORY_EXPERIMENT = 'service_history_experiment',
	UNIT_TEST = 'unit_test',
	UPDATED_GRADING_CONSISTENCY_EXPERIMENT = 'updated_grading_consistency_experiment',
	UPDATED_GRADING_MEASURING_EXPERIMENT = 'updated_grading_measuring_experiment',
}

const GRADING_DECISIONS = {
	ALSO_SHOW_OLD_GRADING: 'also_show_old_grading',
	SHOW_NEW_GRADING: 'show_new_grading',
	SHOW_OLD_GRADING: 'show_old_grading',
};

export const EXPERIMENTS_DECISIONS = {
	DEALER_DASHBOARD: {
		off: 'off',
		on: 'on',
	},
	RECOMMENDED_SORT_ORDER: {
		off: 'off',
		v1: 'v1',
		v2: 'v2',
	},
	SERVICE_HISTORY_EXPERIMENT: {
		// Used in AA Test
		ALSO_SHOW_OLD_SERVICE_HISTORY_VIEW: 'also_show_old_service_history_view',
		SHOW_NEW_SERVICE_HISTORY_VIEW: 'show_new_service_history_view',
		SHOW_OLD_SERVICE_HISTORY_VIEW: 'show_old_service_history_view',
	},
	UPDATED_GRADING_CONSISTENCY_EXPERIMENT: GRADING_DECISIONS,
	UPDATED_GRADING_MEASURING_EXPERIMENT: GRADING_DECISIONS,
} as const;

export const EXPERIMENTS_RULE_KEYS = {
	UPDATED_GRADING_MEASURING_EXPERIMENT: {
		UPDATED_GRADING_MEASURING_AA_TEST_ROLLOUT: 'updated_grading_measuring_aa_test_rollout',
		UPDATED_GRADING_MEASURING_AB_TEST_ROLLOUT: 'updated_grading_measuring_ab_test_rollout',
	},
};
